<template>
    <main role="main">
        <div class="page-bn s3-3bn">
        
        </div>
        <div class="detailed-con" >
            <div class="oops">
                <img src="../../static/images/10/oops2.png" alt="">
                <p>OOPS ! <span>資料顯示錯誤 ! </span></p>
            </div>
        </div>
        <IndexFooter></IndexFooter>
    </main>
</template>
<script>
export default {
  name: 'NotFound',
  data () {
    return {
    }
  },
  mounted () {
  },
  created(){
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Error.vue